import { PaintedScene } from '../PaintedScene';

export const TALKING_STUMP_PHASER_KEY = 'TalkingStumpScene' as const;
export const TALKING_STUMP_MANIFEST_KEY = 's-004-talking-stump' as const;

export class TalkingStumpScene extends PaintedScene {
  constructor() {
    super(TALKING_STUMP_PHASER_KEY, TALKING_STUMP_MANIFEST_KEY);
  }
}
